// extracted by mini-css-extract-plugin
module.exports = {"row":"_3-tGXCIQ","detailsTable":"uHJnd4JD","queryWrapper":"_3GRFPk2B","aceEditor":"_1ZnQSsax"};